"use strict";

import * as leafletMap from "@elements/leaflet-map";
import {find, findAll} from "@elements/dom-utils"
import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    const selectors = {base: '.js-tour-map'};
    onFind('.js-tour-map', function (mapElement) {

        const id = mapElement.dataset.tourId;
        let pois = [{}];

        /*waypoints*/
        // let url = '/de/tour/wayPointAction?id='+ id +'';
        let url = '/../static/dummy-data/tour-waypoints.json';
        let wayPoints = fetch(url, {
            method: 'GET',
            headers: {"content-type": "application/json"}
        }).then((res) => {
            return res.json()
        }).then(function (data) {
            if(data !== null ) {
                createWayPoints(data);
            }
        }).then(function () {
            initLeafletMap();
        });

        function createWayPoints(data) {
            data.wayPoints.forEach(function (elem, index) {
                pois[index] = {
                    id: index,
                    lat: elem.lat,
                    lng: elem.lon,
                    detailInfo: elem.name,
                    poiStyle: "main"
                }
            });
        }

        const infoBoxOptions = {
            maxWidth: matchMedia('(max-width: 767px)').matches ? 250 : 320,
            minWidth: matchMedia('(max-width: 767px)').matches ? 230 : 300,
            className: 'map-infobox'
        };

        function initLeafletMap() {
            leafletMap.init({
                infoBoxOptions,
                tilelayer: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
                leafletOptions: {
                    attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
                    maxZoom: 18,
                    id: 'mapbox/outdoors-v11',
                    accessToken: _config.mapAccessToken
                },
                mapOptions: {
                    center: {lat: 47.01011105170685, lng: 8.482870389663853},
                    zoom: 15,
                    maxZoom: 18,
                },
                pois: pois,
                poiStyles: () => createPoiStyles(),
                onActivateMarker: (marker, api) => onActivateMarker(marker, api),
                onDeactivateMarker: (marker, api) => onDeactivateMarker(marker, api),
                clustering: true,
                clusteringOptions: () => {
                    return {
                        showCoverageOnHover: false,
                        iconCreateFunction: function (cluster) {
                            return L.divIcon({
                                iconSize: [30, 30],
                                iconAnchor: [18, 18],
                                className: 'marker-cluster',
                                html: '<div class="marker-cluster__img--tour"><img src="/static/img/map/cluster-tour.svg"/><span class="marker-cluster__count">' + cluster.getChildCount() + '</span></div>'
                            });
                        }
                    };
                }
            }, selectors);
        }

        /*polylines*/
        leafletMap.getApi(mapElement).then((api) => {

            let map = api.getMapInstance();
            // let url = '/de/tour/gpxDataAction?id=' + id +'';
            let url = '/../static/dummy-data/tour-map-data.json';

            let tourPoints = fetch(url, {
                method: 'GET',
                headers: {"content-type": "application/json"}
            }).then((res) => {
                return res.json()
            }).then(function (data) {
                if(data !== null){
                    drawPolylines(data);
                }
            });

            function drawPolylines(data) {

                let latlngs = [];

                data.polylines.forEach(function (elem, index) {
                    latlngs[index] = [elem.lat, elem.lon];
                });

                let polyline = L.polyline(latlngs, {color: '#BF5F56'}).addTo(map);// zoom the map to the polyline
                map.fitBounds(polyline.getBounds());
            }

            /* tooltips */
            let markers = api.getMarkers();
            markers.map(function(marker) {
                console.log(marker.detailInfo);

                marker.bindTooltip(marker.detailInfo,{
                    direction: 'top',
                    permanent: true,
                    sticky: true,
                    offset: [-4,  -20],
                    opacity: 1
                }).openTooltip();

            });

        })
    });
}

function createPoiStyles() {
    return {
        main: {
            default: L.icon({
                iconUrl: '/static/img/map/poi.svg',
                iconSize: [16, 24],
                iconAnchor: [12, 20],
                popupAnchor: [-154, -12]
            }),
            active: L.icon({
                iconUrl: '/static/img/map/poi-active.svg',
                iconSize: [16, 24],
                iconAnchor: [12, 20],
                popupAnchor: [-154, -12],
            })
        }
    };
}


function onActivateMarker(marker, api) {
    console.log("on activate marker");
}

function onDeactivateMarker(marker, mapObj) {
    console.log("on deactivate marker");
}
